// extracted by mini-css-extract-plugin
export default {"houseSize":"50","house":"house_house__JGkFP","active":"house_active__CPYRT","inactive":"house_inactive__dNUpY","white":"house_white__LrRwc","black":"house_black__F1krL"};